<style>
.select__container {
  margin-top: 10px;
}
.select__container--el {
  display: flex;
  justify-content: space-between;
}
#printModal .v--modal-box.v--modal {
  min-height: 280px !important;
  min-width: 420px !important;
}
.modal__content {
  padding-top: 5px;
}
#printModal .v-input--selection-controls {
  margin-top: 0px;
}
#printModal .v-input--selection-controls.v-input .v-label {
  font-size: 12px;
}
#printModal *:not(.v-icon) {
  font-size: 12px;
}
#printModal .line__wrapper {
  align-items: center;
}
#printModal .line__button--add {
  margin-left: 5px;
}
</style>

<template>
  <Modal
    modalName="printModal"
    title="Wydrukuj"
    :buttons="['print2']"
    @print="print"
    @closed="closed()"
    @opened="opened()"
  >
    <v-form v-model="valid" ref="form">
      <v-layout class="select__container">
        <v-flex xs5 class="modalSelect__layout" id="modalSelect__content">
          <div class="select__container--el">
            <v-select
              :items="sizes"
              label="Wybierz wielkość"
              :height="16"
              v-model="size"
              :rules="sizeRules"
            ></v-select>
          </div>

          <div class="select__container--el">
            <v-select
              :items="scales"
              v-model="scale"
              label="Wybierz skalę"
              :height="16"
              :rules="scaleRules"
            ></v-select>
          </div>
          <v-layout class="line__wrapper">
            <p class="theme--light v-label">Wydruk seryjny</p>
            <v-icon
              class="line__button--add btn__subheader"
              title="Dodaj linię wydruku"
              @click="addLine"
              v-if="!line_geometry"
            >add_circle_outline</v-icon>
            <v-icon
              class="line__button--add btn__subheader"
              title="Usuń linię"
              @click="removeLine"
              v-if="line_geometry"
            >delete_outline</v-icon>
          </v-layout>
        </v-flex>
        <v-spacer/>
        <v-flex xs5 class="modalSelect__layout" id="modalSelect__content">
          <div class="select__container--el">
            <v-select :items="formats"
                      v-model="format"
                      label="Wybierz format"
                      :height="16"
                      :rules="formatRules"></v-select>
          </div>
          <div class="select__container--el">
            <v-select :items="templates"
                      item-text="name"
                      :return-object="true"
                      v-model="template"
                      label="Wybierz orientację"
                      :height="16"
                      :rules="templateRules"></v-select>
          </div>
          <div>
            <v-checkbox label="Podziel wydruk na arkusze formatu A4" v-model="split" hide-details></v-checkbox>
          </div>
          <div>
            <v-checkbox label="Ręczne ustawianie widoku" v-model="manually" hide-details></v-checkbox>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-layout xs5></v-layout>
        <v-spacer/>
        <v-flex xs5></v-flex>
      </v-layout>
    </v-form>
  </Modal>
</template>

<script>
  import Modal from "./Modal";
  import { createOrUpdate } from 'ol/extent.js';
  import Feature from "ol/Feature";
  import { fromExtent } from "ol/geom/Polygon.js";
  import { unByKey } from 'ol/Observable';
  import {
    Style,
    Stroke,
    Fill,
  } from "ol/style";
  import { Translate } from 'ol/interaction.js';
  import Collection from "ol/Collection";
  import { getCenter } from 'ol/extent';
  import { Vector as VectorLayer } from "ol/layer";
  import { Vector as VectorSource } from "ol/source";

  import chain from "lodash/chain";
  import value from "lodash/value";
  import mixin from "lodash/mixin";
  import _ from "lodash/wrapperLodash";
  import map from "lodash/map";
  import split from "lodash/split";

  mixin(_, {
    chain,
    split,
    map
  });
  _.value = value;
  _.prototype.value = value;

  const PAPER_SERIES = {// w centymetrach
    'A0': [116.1, 81.3],
    'A1': [81.7, 57.0],
    'A2': [57.7, 40.0],
    'A3': [40.2, 28.0],
    'A4': [28.7, 20.1]
  };
  const PAPER_EXTENT_STYLE = new Style({
    fill: new Fill({
      color: [255, 255, 255, 0.2]
    }),
    stroke: new Stroke({
      width: 6,
      color: [237, 212, 0, 0.8]
    })
  });


  export default {
    components: {
      Modal
    },
    data: () => ({
      dialog: false,
      sizes: ["A4", "A3", "A2", "A1", "A0"],
      scales: ["1:500", "1:1000", "1:2000", "1:5000", "1:10000"],
      formats: ["PDF", "PNG"],
      templates: [
        {
          name: "Poziomo",
          formated: "_horizontal"
        },
        {
          name: "Pionowo",
          formated: "_vertical"
        }
      ],
      template: undefined,
      size: undefined,
      format: undefined,
      scale: undefined,
      valid: false,
      split: false,
      line_geometry: null,
      sizeRules: [v => !!v || "Wybierz rozmiar wydruku"],
      formatRules: [v => !!v || "Wybierz format wydruku"],
      templateRules: [v => !!v || "Wybierz orientację wydruku"],
      scaleRules: [v => !!v || "Wybierz skalę wydruku"],

      manually: false
    }),
    computed: {
      map() {
        return this.$store.getters.getMap;
      },
    },
    watch: {
      template() {
        this.updatePrintExtent();
      },
      scale() {
        this.updatePrintExtent();
      },
      size() {       
        this.updatePrintExtent();
      },
      manually(_new) {
        if (_new) {
          this.removePrintExtentToMap();
          this.addPrintExtentToMapManual();
        } else {
          this.removePrintExtentToMapManual();
          this.addPrintExtentToMap();
        }
      },
    },
    methods: {
      addLine() {
        this.$root.$emit("addNewLine", "print");
        this.$root.$emit(
          "showSnackbar",
          "#2a579a",
          "Kliknij na mapie, aby rozpocząć rysowanie linii wydruku seryjnego"
        );
      },
      print() {
        if (this.$refs.form.validate()) {
          this.$root.$emit(
            "printCurrentView",
            {
              center: this.getPrintCenter(),
              format: this.format,
              scale: this.scale,
              size: this.size,
              template: this.template.formated,
              split: this.split,
              line: this.line_geometry
            }
          );
        }
      },
      setPrintLine(line) {
        this.line_geometry = line;
      },
      removeLine() {
        this.line_geometry = null;
        this.$root.$emit("removeMapLayer");
      },

      opened() {
        if (this.manually) {
          this.addPrintExtentToMapManual();
        } else {
          this.addPrintExtentToMap;
        }
      },
      closed() {
        this.template = undefined;
        this.size = undefined;
        this.format = undefined;
        this.scale = undefined;
        this.valid = false;
        this.split = false;
        this.removeLine();

        if (this.manually) {
          this.removePrintExtentToMapManual();
        } else {
          this.removePrintExtentToMap();
        }
      },

      updatePrintExtent() {
        if (this.manually) {
          this.refreshGeometryManual();
        } else {
          this.map.render();
        }
      },

      calculatePrintExtent() {
        const self = this;

        if (!self.size || !self.template || !self.scale) {
          return [];
        }

        //pobieranie wartości
        const center = self.map.getView().getCenter();
        const scale = _(self.scale).split(':').map(v => +v).value();

        let paperSize = PAPER_SERIES[self.size];
        if (self.template.formated === self.templates[1].formated) {
          paperSize = [paperSize[1], paperSize[0]];
        }
        const paperToMapunit = _.map(paperSize, v => (v * scale[1]) / 100); //w metrach

        //generowanie
        const dx = paperToMapunit[0] / 2;
        const dy = paperToMapunit[1] / 2;
        const x = center[0];
        const y = center[1];
        const x1 = x - dx;
        const x2 = x + dx;
        const y1 = y - dy;
        const y2 = y + dy;

        return createOrUpdate(Math.min(x1, x2), Math.min(y1, y2), Math.max(x1, x2), Math.max(y1, y2));
      },
      getGeometryFromExtent(extent) {
        if (extent.length === 4) {
          return fromExtent(extent);
        } else {
          return null;
        }
      },

      executPrintExtent(event) {
        const geometry = this.getGeometryFromExtent(this.calculatePrintExtent());
        event.vectorContext.drawFeature(new Feature({ geometry }), PAPER_EXTENT_STYLE);
      },
      addPrintExtentToMap() {
        if (!this.listenerPrintExtent) {
          this.listenerPrintExtent = this.map.on('postcompose', this.executPrintExtent.bind(this));
        }
      },
      removePrintExtentToMap() {
        if (this.listenerPrintExtent) {
          unByKey(this.listenerPrintExtent);
          this.listenerPrintExtent = false;
        }
      },

      refreshGeometryManual() {
        const geometry = this.getGeometryFromExtent(this.calculatePrintExtent());
        if (geometry) {
          this.layerPrintExtent.feature.setGeometry(geometry);
        }
      },
      addPrintExtentToMapManual() {
        if (!this.layerPrintExtent) {
          const feature = new Feature({})

          const features = new Collection();
          features.push(feature);

          this.layerPrintExtent = new VectorLayer({
            source: new VectorSource({
              features
            }),
            zIndex: 10000,
            visible: true,
            style: PAPER_EXTENT_STYLE
          });       
          this.map.addLayer(this.layerPrintExtent);

          const translate = new Translate({
            features,
          });
          this.map.addInteraction(translate);


          this.layerPrintExtent.feature = feature;
          this.layerPrintExtent.translate = translate;

          this.refreshGeometryManual();
        }
      },
      removePrintExtentToMapManual() {
        if (this.layerPrintExtent) {
          this.map.removeInteraction(this.layerPrintExtent.translate);
          this.map.removeLayer(this.layerPrintExtent);
          this.layerPrintExtent = false;
        }
      },
      
      getPrintCenter() {
        if (this.layerPrintExtent) {
          const geometry = this.layerPrintExtent.feature.getGeometry();
          if (geometry) {
            return getCenter(geometry.getExtent());
          }
        }
        return this.map.getView().getCenter();
      }
    },
    mounted() {
      this.listenerPrintExtent = false;
      this.$root.$on("setPrintLine", this.setPrintLine);
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/shared/Print.vue